var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{attrs:{"href":_vm.path,"target":"_blank","download":""}},[_vm._v(_vm._s(_vm.$getFileName(_vm.path)))])
}
var staticRenderFns = []

export { render, staticRenderFns }